export const fieldsCertificateInfoCertificate = {
  licenseCaption: {
    key: "licenseCaption",
    caption: "Удостоверение",
    needInForm: true,
  },
  licenseNum: {
    key: "licenseNum",
    label: "Номер удостоверения",
    type: "text",
    needInForm: true,
    cssKey: "left",
    placeholder: "Введите",
    maxLength: 6,
  },
  licenseTypeId: {
    key: "licenseTypeId",
    label: "Тип удостоверения",
    type: "selectWithSearch",
    needInForm: true,
    cssKey: "left",
    disabled: true,
    options: [
      {
        value: 1,
        label: "Республиканское",
        key: "licenseTypeId",
      },
      {
        value: 2,
        label: "Международное",
        key: "licenseTypeId",
      },
    ],
  },
  validFor: {
    key: "validFor",
    label: "Действительно для",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "left",
    required: true,
  },
  validForEn: {
    key: "validForEn",
    label: "Valid for",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    required: true,
    pattern: {
      value: /^[a-zA-Z\s.,;:!?'"-]*$/,
      message: `Заполнение на английском языке`,
    },
    cssKey: "left",
  },
  licenseDocDepartment: {
    key: "licenseDocDepartment",
    label: "Выдано",
    type: "text",
    needInForm: true,
    cssKey: "right",
    disabled: true,
  },
  licenseDate: {
    key: "licenseDate",
    label: "Дата выдачи",
    type: "date",
    needInForm: true,
    cssKey: "right",
    customValidation(value) {
      if (new Date(value) > new Date()) {
        return "Дата не может быть позднее текущей";
      } else {
        return true;
      }
    },
  },
  licenseDateEnd: {
    key: "licenseDateEnd",
    label: "Действительно до",
    type: "date",
    needInForm: true,
    cssKey: "right",
    customValidation(value, getValues) {
      if (getValues.licenseDate && new Date(getValues.licenseDate) > new Date(value)) {
        return "Дата не может быть раньше даты выдачи";
      } else {
        return true;
      }
    },
  },
};

export const setupOptionsCertificateInfoByCertificateType = (typeId) => {
  if (Number(typeId) === 1) {
    for (let item in fieldsCertificateInfoCertificate) {
      if (
        fieldsCertificateInfoCertificate[item].key.includes("En") &&
        fieldsCertificateInfoCertificate[item].key !== "licenseDateEnd"
      ) {
        fieldsCertificateInfoCertificate[item].needInForm = false;
      }
    }
    fieldsCertificateInfoCertificate.validFor.required = false;
  } else {
    for (let item in fieldsCertificateInfoCertificate) {
      if (
        fieldsCertificateInfoCertificate[item].key.includes("En") &&
        fieldsCertificateInfoCertificate[item].key !== "licenseDateEnd"
      ) {
        fieldsCertificateInfoCertificate[item].needInForm = true;
      }
    }
    fieldsCertificateInfoCertificate.validFor.required = true;
  }
  return fieldsCertificateInfoCertificate;
};

export const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #BC865399",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
export const customErrorStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #dc3545",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
